// Where a signed-in user lands when nothing else decided it — the bare origin after a fresh
// redirect sign-in, or /login visited while already authenticated. Everyone who followed a link
// was already put back by savePostAuthRedirect/restorePostAuthRedirect; this is the residual
// case only. The bet is the default: the Memory product's home, /memory (the trees and what they
// did for you). Analytics is the exception, for accounts that have analytics projects — a small,
// known, contracted set. The account page (/agent) is one tab away, not the front door.
export const AGENT_HOME = "/memory";
export const ANALYTICS_HOME = "/";
export const START_PATH = "/start";
// Where "get the agent" goes: the Memory section of the marketing site (its pricing block carries
// the agent download and the plugin install). agent.assertion-ai.com is retired in its favour.
export const AGENT_SITE = "https://assertion-ai.com/#pricing";
// The help page on the marketing site. The installed agent links to studio.../help, which is
// routed here (app.js) so that link keeps working without Studio carrying a copy of the doc.
export const HELP_URL = "https://assertion-ai.com/help";

// `product` comes from the link that started the sign-in: the analytics site's "Try it free" sends
// /start?product=analytics, and that visitor must land in analytics even with no projects yet.
// `plan=starter` (its Starter button) goes on to the billing page to finish the upgrade.
export function landingFor(projects, { product, plan } = {}) {
  if (product === "analytics") return plan === "starter" ? "/billing?plan=starter" : ANALYTICS_HOME;
  return Array.isArray(projects) && projects.length > 0 ? ANALYTICS_HOME : AGENT_HOME;
}
// Whether a signed-out visitor was on their way into Analytics: an analytics page, or the site's
// "Try it free" (/start?product=analytics). /login shows those visitors what Analytics is before
// the sign-in button. Everything else — the plugin's /connect and /memory, the Mac app's /device,
// /account, a bare /start or / — keeps the plain screen, so the sign-ins that already work are
// untouched and a Memory user is never shown an Analytics pitch.
const ANALYTICS_PAGES = ["/analyze", "/projects", "/runs", "/data", "/dictionaries", "/billing", "/settings"];
export function isAnalyticsDestination(path) {
  if (typeof path !== "string" || !path.startsWith("/")) return false;
  const url = new URL(path, "https://studio.invalid");
  if (url.pathname === START_PATH) return url.searchParams.get("product") === "analytics";
  return ANALYTICS_PAGES.some((p) => url.pathname === p || url.pathname.startsWith(`${p}/`));
}
// The public sample report (no sign-in), for a visitor who wants to see an answer first.
export const SAMPLE_REPORT = "/demo/retention-report.html";

// The Mac app itself. /agent/download counts a download against its channel, then starts this.
export const AGENT_DMG = "https://storage.googleapis.com/assertion-downloads/desktop/latest/assertion-desktop-mac-arm64.dmg";
